export interface PlanEditorServiceItem {
  name: string
  isIncluded: boolean
  isPartial: boolean
  quantity: string
}

export interface PlanEditorCategoryGroup {
  category: string
  services: PlanEditorServiceItem[]
}

export const DEFAULT_SERVICES_TEMPLATE: PlanEditorCategoryGroup[] = [
  {
    category: 'Gestão de Tráfego e Performance',
    services: [
      { name: 'Google Ads (Search & Shopping)', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'Meta Ads (Instagram & Facebook)', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'TikTok Ads (Vídeos curtos)', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'LinkedIn Ads (B2B Corporativo)', isIncluded: false, isPartial: false, quantity: '' },
    ],
  },
  {
    category: 'Criação & Design Visual',
    services: [
      { name: 'Criação de Anúncios (Estáticos)', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'Criação de Vídeos para Anúncios', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'Landing Pages de Alta Conversão', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'Ajuste de Identidade Visual / KV', isIncluded: false, isPartial: false, quantity: '' },
    ],
  },
  {
    category: 'Tecnologia & Dados',
    services: [
      { name: 'Configuração de Pixel & API de Conversão', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'Dashboard GA4 & Looker Studio', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'Integração CRM & Automação de Leads', isIncluded: false, isPartial: false, quantity: '' },
    ],
  },
  {
    category: 'Acompanhamento & Estratégia',
    services: [
      { name: 'Reuniões Mensais de Alinhamento', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'Relatório de Resultados Semanais', isIncluded: false, isPartial: false, quantity: '' },
      { name: 'Análise de Concorrentes & Benchmarks', isIncluded: false, isPartial: false, quantity: '' },
    ],
  },
]
